module.exports = __webpack_public_path__ + "static/img/051天气预报.0ca64be.png";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/051天气预报.png
// module id = 53Bo
// module chunks = 0